module Meevo.Plugins.Register.Controls {
    "use strict";

    export class MeevoRefundTotalsFooter implements angular.IDirective {
        restrict = "E";
        require = "ngModel";
        scope = {           
            model: '=ngModel',
            apply: '&'
        };

        templateUrl = "app/plugins/register/directives/refundTotalsFooterTemplate.html";

        link = (scope: any) => {
            scope.$watchCollection('[model.refundSubTotal, model.refundTax, model.prepaidTipAmount]', () => {
                scope.model.refundTotal = scope.model.refundSubTotal + scope.model.refundTax + (scope.model.prepaidTipAmount || 0);
            });
        }

        static factory(): angular.IDirectiveFactory {
            let directive = () => {
                return new MeevoRefundTotalsFooter();
            };

            return directive;
        }
    }

    angular.module("meevo.components.controls")
        .directive("meevoRefundTotalsFooter", MeevoRefundTotalsFooter.factory());
}